import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';

import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { IpmatMockAttemptComponent } from './ipmat-mock-attempt/ipmat-mock-attempt.component';
import { CommonChildComponentsModule } from '../components/common-components.module';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatTooltipModule,
    MatDialogModule,
    MatSnackBarModule,
    MatButtonModule,
    RouterModule,
    NgxSpinnerModule,
    CommonChildComponentsModule
  ],

  declarations: [
    IpmatMockAttemptComponent
  ],

  exports: [
    IpmatMockAttemptComponent
  ],
  providers: [
    DatePipe,
  ]

})
export class AllMocksModule { }
